module.exports = __webpack_public_path__ + "static/img/guardians.f236ae0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grid/guardians.jpg
// module id = EKt1
// module chunks = 0